/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pm_Linked_CountInputs */

const cs_pm_linked_count = /** @type {(inputs: Pm_Linked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Propojeno: ${i?.n}`)
};

const en_pm_linked_count = /** @type {(inputs: Pm_Linked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linked: ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Linked: {n}" |
*
* @param {Pm_Linked_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_linked_count = /** @type {((inputs: Pm_Linked_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Linked_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_linked_count(inputs)
	return cs_pm_linked_count(inputs)
});